import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wall",
  "use": "icon-wall-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wall\"><path d=\"M128 128h480v224H128zM416 416h480v224H416zM128 416h224v224H128zM672 704h224v192H672zM672 128h224v224H672zM128 704h480v192H128z\" p-id=\"5957\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol